import { Bar, mixins } from 'vue-chartjs'
import _ from 'lodash'
const { reactiveProp } = mixins

export default {
  extends: Bar,
  props: ['options', 'dataTypes'],
  mixins: [reactiveProp],
  computed: {
    parsedChartData () {
      const dataClone = _.cloneDeep(this.chartData)
      dataClone.datasets.map(dataset => {
        if (this.dataTypes) {
          if (this.dataTypes[dataset.label] === 'percentage') {
            dataset.data = dataset.data.map(value => Math.round(value))
          } else {
            dataset.data = dataset.data.map(value => value.toFixed(2))
          }
        }
        return dataset
      })
      return dataClone
    },
    optionsWithCustomTooltip () {
      const optionsCopy = _.cloneDeep(this.options)
      if (!optionsCopy.tooltips) {
        optionsCopy.tooltips = {
          enabled: false,
          custom: function (tooltipModel) {
            // Tooltip Element
            let tooltipEl = document.getElementById('chartjs-tooltip')

            // Create element on first render
            if (!tooltipEl) {
              tooltipEl = document.createElement('div')
              tooltipEl.id = 'chartjs-tooltip'
              tooltipEl.innerHTML = '<table></table>'
              document.body.appendChild(tooltipEl)
            }

            // Hide if no tooltip
            if (tooltipModel.opacity === 0) {
              tooltipEl.style.opacity = 0
              return
            }

            // Set caret Position
            tooltipEl.classList.remove('above', 'below', 'no-transform')
            if (tooltipModel.yAlign) {
              tooltipEl.classList.add(tooltipModel.yAlign)
            } else {
              tooltipEl.classList.add('no-transform')
            }

            function getBody (bodyItem) {
              return bodyItem.lines
            }

            // Set Text
            if (tooltipModel.body) {
              let bodyLines = tooltipModel.body.map(getBody)

              let innerHtml = '<div class="d-flex flex-column">'
              innerHtml += '</div><div class="d-flex flex-column">'

              bodyLines[0].forEach(function (body, i) {
                innerHtml += '<span>' + `${Number(body) % 1 === 0 ? body + '%' : body}` + '</span>'
              })
              innerHtml += '</div>'

              let tableRoot = tooltipEl.querySelector('table')
              tableRoot.innerHTML = innerHtml
            }

            // `this` will be the overall tooltip
            let position = this._chart.canvas.getBoundingClientRect()

            // Display, position, and set styles for font
            tooltipEl.style.opacity = 1
            tooltipEl.style.backgroundColor = 'rgba(0,0,0,0.73)'
            tooltipEl.style.color = 'white'
            tooltipEl.style.position = 'absolute'
            const caretPosition = tooltipModel.caretX > position.left ? position.left + window.pageXOffset + tooltipModel.caretX - 60 : position.left + window.pageXOffset + tooltipModel.caretX
            tooltipEl.style.left = `${caretPosition}px`
            tooltipEl.style.top = position.top + window.pageYOffset + tooltipModel.caretY + 'px'
            tooltipEl.style.fontFamily = tooltipModel._bodyFontFamily
            tooltipEl.style.fontSize = tooltipModel.bodyFontSize + 'px'
            tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle
            tooltipEl.style.padding = tooltipModel.yPadding + 'px ' + tooltipModel.xPadding + 'px'
            tooltipEl.style.pointerEvents = 'none'
          },
          callbacks: {
            label: (tooltipItem, data) => {
              const dataType = data.datasets[0].label
              return [dataType, tooltipItem.yLabel]
            }
          }
        }
      }
      return optionsCopy
    }
  },
  mounted () {
    this.renderChart(this.parsedChartData, this.optionsWithCustomTooltip)
  }
}
